import { motion } from "framer-motion";

export const Card = ({
  children,
  className = "",
  hover = false,
  onClick = () => {},
  delay = 0,
}) => {
  const baseClasses = "card";
  const hoverClasses = hover ? "card-hover" : "";

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay }}
      className={`${baseClasses} ${hoverClasses} ${className}`}
      onClick={onClick}
      whileHover={hover ? { scale: 1.02 } : {}}
    >
      {children}
    </motion.div>
  );
};
